if (!customElements.get('bundle-body-cart')) {
  customElements.define('bundle-body-cart', class BundleBodyCart extends HTMLElement {
    constructor() {
      super();

      this.customerId = ShopifyAnalytics.meta.page.customerId;
      this.arrayLineOfItems = [];
      this.arrayLineOfItemsDraft = [];
      this.arrayOfItems = [];
      this.arrayOfItemsDraft = [];

      this.forms = this.querySelectorAll('[data-js-bundle-item-form]');
      this.inputs = this.querySelectorAll('[data-name="quantity"]');
      this.addToDraftButton = this.querySelector("[data-add-draft-cart]");
      this.cart = document.querySelector('cart-drawer');
      this.attachListener();
      this.inputValidation();
    }

    attachListener() {
      this.addToDraftButton.addEventListener(
        "click",
        this.addToDraft.bind(this)
      );
    }
    inputValidation() {
      this.inputs.forEach(input => {
        input.addEventListener('change', (e) => {

          let minValue = +e.target.min;
          let maxValue = +e.target.max;
          let currentValue = +e.target.valueAsNumber;

          if (currentValue > maxValue) {
            e.target.value = maxValue;
          } else if (currentValue < minValue) {
            e.target.value = minValue;
          } else {
            e.target.value = currentValue;
          }
        });
      });
    }

	clearCart() {
		fetch('/cart/clear.js', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				'Accept': 'application/json'
			}
		})
			.then(response => {
				if (response.ok) {
					const cartCount = document.querySelector('.cart-count-bubble-custom span');
					let cartDrawerSection = document.querySelector('drawer__content');
          console.log('response', response);
					this.loadCartDrawerSection();
					this.cart.classList.add('is-empty');
					cartCount.innerHTML = 0;
					cartDrawerSection.close(document.querySelector('#cart-icon-bubble'));
				} else {
					console.error('Error when emptying cart');
				}
			})
			.catch(error => {
				console.error('Error executing the request:', error);
			});
	}

    successMessageDraftOrder() {
      const successMessageDisplay = document.querySelector(".input__success-message");
      successMessageDisplay.style.display = 'flex';
      this.arrayLineOfItemsDraft = [];
      setTimeout(()=>{
        successMessageDisplay.style.display = 'none';
        this.addToDraftButton.removeAttribute('disabled');
      }, 4000);
    }

    loadCartDrawerSection(){
      console.log('loadCartDrawerSection');
      fetch('/cart?section_id=cart-drawer')
      .then(res => res.text())
      .then(html => {
				console.log('loadCartDrawerSection - response', html);
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const newDrawer = doc.querySelector('[data-id="CartDrawer"]'); // this is how Hyper marks the drawer

        const drawerContainer = document.querySelector('[data-id="CartDrawer"]');
        if (drawerContainer && newDrawer) {
          drawerContainer.innerHTML = newDrawer.innerHTML;

          // Open the drawer (Hyper handles this with a toggle attribute)
          document.querySelector('[data-id="CartDrawer"]')?.setAttribute('open', '');
          document.querySelector('[data-id="CartDrawerOverlay"]')?.classList.remove('hidden');
          document.body.classList.add('overflow-hidden');
        }
      })
      .catch(error => {
        console.error('Cart error:', error);
      });
    }

    errorMessageDraftOrder() {
      const errorMessageDisplay = document.querySelector(".input__error-message");
      errorMessageDisplay.style.display = 'flex';
      setTimeout(()=>{
        errorMessageDisplay.style.display = 'none';
        this.addToDraftButton.removeAttribute('disabled');
      }, 4000);
    }

    defineDraftElements() {

      Array.from(this.forms).forEach(item => {
        let variantId = item.querySelector("[data-name='id']").value;
        let variantTitle = item.querySelector("[data-name='product_title']").value;
        let variantPrice = item.querySelector("[data-name='product_price']").value;
        let itemValue = item.querySelector("[data-name='quantity']").value;
        this.arrayLineOfItemsDraft.push({
          "variant_id": variantId,
          "quantity": itemValue,
          "title": variantTitle,
          "price": variantPrice
        });
      });
    }


    addToDraft(e) {
      e.preventDefault();
      this.addToDraftButton.setAttribute("disabled", "disabled");
      this.defineDraftElements();
      this.addToDraftItem();
    }

    addToDraftItem() {
      this.arrayOfItemsDraft = JSON.stringify(
        {
          "draft_order": {
            "line_items": [...this.arrayLineOfItemsDraft],
            "customer": {
              "id": this.customerId
            }
          }
        }
      );
      if (this.customerId) {
        const myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");

        const requestOptions = {
          method: 'POST',
          redirect: 'follow',
          body: this.arrayOfItemsDraft
        };

        fetch("https://rl6abopd9j.execute-api.ap-southeast-2.amazonaws.com/default/postDraftsOrdersPipecore-API", requestOptions)
        .then(response => response.text())
        .then(result => {
          this.successMessageDraftOrder();
		  this.clearCart();
        })
        .catch(error => {
          console.log('error', error);
          this.errorMessageDraftOrder();
        });
      } else {
        this.errorMessageDraftOrder();
      }
    }
  });
}
